import ClaimType from 'models/claims/claimType/Model.ClaimType';
import Model from 'models/Model';
import DealerGroup from '../dealerGroup/Model.DealerGroup';

export default class DealerGroupClaimType
  extends Model<Model.IDealerGroupClaimType>({ icon: 'if-login' })
  implements Model.Instance<Model.IDealerGroupClaimType>
{
  id: number;
  claimTypeId: number;
  claimType?: ClaimType;
  dealerGroupId: number;
  dealerGroup?: DealerGroup;
  isClaimTypeAutomationEnabled?: boolean;

  constructor(
    data: Partial<Model.IDealerGroupClaimType> | Utils.FormData<Model.IDealerGroupClaimType>,
    language?: Locale.Languages
  ) {
    super(
      {
        dealerGroup: DealerGroup,
        claimType: ClaimType,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }
}
